import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useAppDispatch } from '../app/store';
import { refreshLoginUser } from '../features/auth/authApi';

interface AuthContextProps {
    isAuthenticated: boolean;
    login: (token: string, expiresIn: number) => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const token = Cookies.get('token');
        const tokenExpiry = Cookies.get('tokenExpiry');

        if (token && tokenExpiry) {
            const expiryTime = parseInt(tokenExpiry, 10);
            const currentTime = new Date().getTime();
            if (currentTime < expiryTime) {
                setIsAuthenticated(true);

                //Trigger refresh token
                // dispatch(refreshLoginUser());
                    // .unwrap()
                    // .then((response) => {
                    //     if (response?.status && response?.status === 'success' && response?.data?.access_token && response?.data?.user?.login_cnt > 1) {
                    //         login(response.data.access_token, parseInt(response.data.expires_in));
                    //     }
                    //     else {
                    //         logout();
                    //     }
                    // })
                    // .catch((error) => {
                    //     console.error('Failed to refresh token:', error);
                    // });
            } else {
                logout();
            }
        }
    }, []);

    const login = (token: string, expiresIn: number) => {
        const expiryTime = new Date().getTime() + expiresIn * 60 * 1000;
        Cookies.set('token', token, { secure: false, sameSite: 'Lax' });
        Cookies.set('tokenExpiry', expiryTime.toString(), { secure: false, sameSite: 'Lax' });
        setIsAuthenticated(true);
    };

    const logout = () => {
        Cookies.remove('token');
        Cookies.remove('tokenExpiry');
        setIsAuthenticated(false);
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextProps => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};